import { EscrowFees } from '../constants/escrow-fees'

export enum RuleOperators {
  Equal = 'equal',
  NotEqual = 'not_equal',
  MoreThen = 'more_than',
  MoreThenOrEqual = 'more_than_or_equal',
  LessThen = 'less_than',
  LessThanOrEqual = 'less_than_or_equal',
  In = 'in',
  NotIn = 'not_in',
  Intersects = 'intersects',
  EachIntersects = 'each_intersects',
}

export enum FactNames {
  CampaignAppliedCount = 'campaign_applied_count',
  OrderValue = 'order_value',
  ContextCatalogIds = 'context_catalog_ids',
  BuyerNthCarrierPurchase = 'buyer_nth_carrier_purchase',
  BuyerNthPurchase = 'buyer_nth_purchase',
  SellerNthSale = 'seller_nth_sale',
  LastMileCarrierCode = 'last_mile_carrier_code',
  PackageSizeCode = 'package_size_code',
  DropOffType = 'drop_off_type',
  SellerCountryCode = 'seller_country_code',
  BuyerCountryCode = 'buyer_country_code',
  FulfillmentServiceType = 'fulfilment_service_type',
  SellerTargetedCampaignName = 'seller_targeted_campaign_name',
  BuyerTargetedCampaignName = 'buyer_targeted_campaign_name',
}

export type ConditionGroupDto = {
  id: string
  parent_id: string
  any: {
    id: string
    parent_id: string
    items: Array<ConditionDto>
  }
}

type ConditionValue = string | Array<string> | number | Array<number> | null

export type ConditionDto = {
  fact: FactNames
  operator: RuleOperators
  value: ConditionValue
  id: string
  parent_id: string
}

type ConditionTreeDto = {
  id: string
  all: {
    id: string
    parent_id: string
    items: Array<ConditionGroupDto | ConditionDto>
  }
}

export type PricingRuleDto = {
  condition_tree: ConditionTreeDto
  currency: string
  end_date: string
  start_date: string
  exact_amount: string | null
  fixed_amount: string | null
  id: string
  name: string
  percentage: string | null
  type: EscrowFees
}

export type PricingRuleModel = {
  conditionTree: ConditionTreeDto
  currency: string
  endDate: string
  startDate: string
  exactAmount: string | null
  fixedAmount: string | null
  id: string
  name: string
  percentage: string | null
  type: EscrowFees
}

export type GetPricingRulesResponse = Array<PricingRuleDto>

export type PricingRulesModel = Array<PricingRuleModel>

export const isFactGroup = (item: unknown): item is ConditionGroupDto => {
  if (typeof item === 'object' && item !== null) {
    return 'any' in item
  }

  return false
}

export const isSingleFact = (field: ConditionDto | ConditionGroupDto): field is ConditionDto => {
  return !('any' in field)
}
